<template lang="html">
  <div id="d-page-template-1">

    <!-- <section class="search-section-s1">
      <b-form @submit="onSubmit">
        <b-form-group class="form-group-s1">
          <b-form-input
          v-model="formSearch.keywords"
          type="text"
          placeholder="Buscar..."
          required
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" class="btn-search">
          <i class="far fa-search"></i>
        </b-button>
      </b-form>
    </section> -->

    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-sm-6 col-title">
          <h2>Vacantes</h2>
        </div>
      </div>
    </section>

    <section class="requests-section">
      <div class="box-results">
        <b-card no-body>
          <b-tabs class="tabs-lg" card>

            <!-- Aptos para tu perfil -->
            <b-tab title="Aptos para tu perfil" active>
              <b-card-text>
                <router-link class="post-template-s5"
                  :to="{ name: 'accBolsaOfeDetallePage', params: { id: o.id } }"
                  v-for="(o, oInx) in rows" :key="'oInx-'+oInx">
                  <div class="box-main-content">
                    <div class="box-top">
                      <div class="col col-title">
                        <h5 class="title">{{o.name}}</h5>
                      </div>

                      <div class="col col-posted">
                        <h6 class="date">Publicado {{o.created}}</h6>
                      </div>

                      <div class="col-12 col-location">
                        <h5 class="subtitle">{{o.state}}, {{o.town}}.</h5>
                        <div class="box-bubbles" v-for="(dep, indd) in o.departaments" :key="'dep-'+indd">
                          <span class="bubble">{{dep.name}}</span>
                        </div>
                      </div>
                      <div class="col-12 col-location">
                        <h5 class="subtitle">Numero de vacantes: </h5> <span style="color: black;">{{ o.number_vacancies }}</span><br>
                        <h5 class="subtitle">Agencia: </h5> <span style="color: black;">{{ o.agency }}</span>
                      </div>
                    </div>

                    <div class="box-info">
                      
                      <div class="descr">
                        <p v-html="o.requirements"></p>
                      </div>
                    </div>
                  </div>
                </router-link>
              </b-card-text>
            </b-tab>
            <!--  -->

            <!-- Otros perfiles -->
            <b-tab title="Otros perfiles">
              <b-card-text>
                <router-link class="post-template-s5"
                :to="{ name: 'accBolsaOfeDetallePage', params: { id: ot.id } }"
                  v-for="(ot, oInx) in others" :key="'othInx-'+oInx"
                  >
                  <div class="box-main-content">
                    <div class="box-top">
                      <div class="col col-title">
                        <h5 class="title">{{ot.name}}</h5>
                      </div>

                      <div class="col col-posted">
                        <h6 class="date">Publicado {{ot.created}}</h6>
                      </div>

                      <div class="col-12 col-location">
                        <h5 class="subtitle">{{ot.state}}, {{ot.town}}.</h5>
                        <div class="box-bubbles" v-for="(dep, indd) in ot.departaments" :key="'dep-'+indd">
                          <span class="bubble">{{dep.name}}</span>
                        </div>
                      </div>

                      <div class="col-12 col-location">
                        <h5 class="subtitle">Numero de vacantes: </h5> <span style="color: black;">{{ ot.number_vacancies }}</span><br>
                        <h5 class="subtitle">Agencia: </h5> <span style="color: black;">{{ ot.agency }}</span>
                      </div>

                     

                    </div>

                    <div class="box-info">
                      <!-- <h6 class="date">
                        <span class="days">Numero de vacantes{{ot.number_vacancies}}</span>
                        
                      </h6> -->

                      <div class="descr">
                        <p v-html="ot.requirements"></p>
                      </div>
                    </div>
                  </div>
                </router-link>
              </b-card-text>
            </b-tab>
            <!--  -->

          </b-tabs>
        </b-card>
      </div>
    </section>

  </div>
</template>


<script>
export default {
  data() {
    return {
      formSearch: {
        keywords: null
      },
      rows:[],
      others:[],
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },
    getRows(){
      axios.get(tools.url("/api/jobs")).then((response)=>{
          this.rows = response.data.jobs;
          this.others = response.data.others;
          
      }).catch(()=>{});
    }
  },
  mounted(){
      this.getRows();
  }
}
</script>
